<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
export default
{
    name: 'mv-guide-form',

    props:
    {
        model: Object,
        edit: Boolean,
    },

    computed:
    {
        ...mapGetters({locale: 'generalCurrentLocale',}),
    },

    methods:
    {
        save()
        {
            this.$emit('save')
        },

        submit()
        {
            this.$refs.form.submit()
        },

        addFile(file)
        {
            this.model.attachments.push(file)
        },

        removeFile(file)
        {
            for (let i = 0; i < this.model.attachments.length; ++i)
            {
                const item = this.model.attachments[i]
                if (file.id == item.id)
                {
                    this.model.attachments.splice(i, 1)
                }
            }

        },

    },

    data()
    {
        return {
        }
    },

}
</script>

<template>
<div class="container">
    <form @submit.prevent.stop="save" ref="form">
        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('GENERAL.YEAR') }}
            </label>
            <div class="col-md-8">
                <input type="number" class="form-control" v-model="model.year">
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('GENERAL.FILE') }}
            </label>
            <div class="col-md-8">
                <label class="btn btn-sm btn-primary">
                    <mv-uploader ref="uploader" @upload-done="addFile($event)" accept="*/*" any></mv-uploader>
                    <icon name="file"></icon>
                </label>
            </div>
        </div>

        <div class="form-group row">
            <div class="col-md-4">

            </div>
            <div class="col-md-8">
                <mv-attachment v-for="img in model.attachments" :key="img.id" :attachment="img" can-remove @remove="removeFile">
                </mv-attachment>
            </div>
        </div>
    </form>
</div>
</template>


// WEBPACK FOOTER //
// src/components/forms/GuideForm.vue